Cart = {
    apiUrl: '/dopolnitelnye_materialy/cart',

    add: function (id) {
        var me = this;

        $.ajax({
            type: "GET",
            url: this.apiUrl + "/add",
            data: ({id: id}),
            dataType: 'json',
            success: function (msg) {
                me.updateWidget();
                setTimeout(function () {
                    $('#tooltip-cart').focus().popover('show');
                    $('#tooltip-cart>.swing').addClass('active');
                }, 300);
                setTimeout(function () {
                    $('#tooltip-cart').popover('hide');
                    $('#tooltip-cart>.swing').removeClass('active');
                }, 5000);
            }
        });
    },

    delete: function (id) {
        $.ajax({
            type: "GET",
            url: this.apiUrl + "/delete",
            data: ({id: id}),
            dataType: 'json',
            success: function (msg) {
                location.reload();
            }
        });
    },

    change: function (materialId, count) {
        $.ajax({
            type: "GET",
            url: this.apiUrl + "/change",
            data: ({id: materialId, count: count}),
            dataType: 'json',
            success: function (msg) {
                location.reload();
            }
        });
    },

    reCalc: function () {
        location.reload();
    },

    clear: function () {
        $.ajax({
            type: "GET",
            url: this.apiUrl + "/clear",
            dataType: 'json',
            success: function () {
                location.reload();
            }
        });
    },

    updateWidget: function () {
        var widgetContainer = $('#cart-container');

        if (widgetContainer.length > 0) {
            $.ajax({
                type: "GET",
                url: this.apiUrl + "/state",
                dataType: 'json',
                success: function (data) {
                    widgetContainer.html(data);
                }
            });
        }
    }
};


$('.cart-change-count')
    .focusout(function (e) {
        Cart.change($(this).attr("data-id"), $(this).val());
    })
    .keyup(function (e) {
        if (e.keyCode == 13) {
            Cart.change($(this).attr("data-id"), $(this).val())
        }
    });



